var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"youtube-image__wrapper"},[_c('SocialImage',_vm._g(_vm._b({class:[_vm.data.class, _vm.data.staticClass],attrs:{"title":"YouTube","channel":"youtube"}},'SocialImage',_vm.data.attrs,false),_vm.listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }